import { type InitOptions } from '../../common/models/common.models';

export enum BreadcrumbsEvents {
    disableLinks = 'breadcrumbs/disableLinks',
    changeSurveyName = 'breadcrumbs/changeSurveyName',
    updateParams = 'breadcrumbs/updateParams',
    initialize = 'breadcrumbs/initialize',
    outsideScroll = 'breadcrumbs/outsideScroll',
    initData = 'breadcrumbs/initData',
    refreshLaunchParams = 'breadcrumbs/refreshLaunchParams',
}

// disable links event for TCP
const toggleLinks = function (links: any) {
    const event = new CustomEvent(BreadcrumbsEvents.disableLinks, {
        detail: links,
    });
    window.dispatchEvent(event);
};

const changeSurveyName = function (surveyName: string) {
    const event = new CustomEvent(BreadcrumbsEvents.changeSurveyName, {
        detail: surveyName,
    });
    window.dispatchEvent(event);
};

const updateParams = function (params: any) {
    const event = new CustomEvent(BreadcrumbsEvents.updateParams, {
        detail: params,
    });
    window.dispatchEvent(event);
};

const initialize = function initialize(options: InitOptions) {
    const event = new CustomEvent(BreadcrumbsEvents.initialize, {
        detail: options,
    });
    window.dispatchEvent(event);
};

const setIsOutsideScroll = function (isOutsideScroll: number) {
    const event = new CustomEvent(BreadcrumbsEvents.outsideScroll, {
        detail: isOutsideScroll,
    });
    window.dispatchEvent(event);
};

const refreshLaunchParams = function () {
    window.dispatchEvent(new CustomEvent(BreadcrumbsEvents.refreshLaunchParams));
};

const initData = function () {
    window.dispatchEvent(new CustomEvent(BreadcrumbsEvents.initData));
};

// all the events callbacks for TCP
export default {
    initData,
    toggleLinks,
    changeSurveyName,
    initialize,
    updateParams,
    setIsOutsideScroll,
    refreshLaunchParams,
};
